var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FB87786E-47AB-4CA1-A880-C31C6AB467CC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,1.54279687 L10.2000703,1.79988281 L10.4572266,0 L9.088125,1.36905469 C8.15620312,0.734648437 7.03057031,0.363632812 5.81817187,0.363632812 C2.60486719,0.363632813 0,2.9685 0,6.18182812 C0,9.39515625 2.60486719,12 5.81817187,12 C9.03145312,12 11.6363437,9.39513281 11.6363437,6.18182813 C11.6363437,4.96942969 11.2653281,3.84375 10.6309219,2.91182813 L12,1.54279687 Z M5.81817187,10.5454453 C3.40821094,10.5454453 1.45453125,8.59176562 1.45453125,6.18180469 C1.45453125,3.77184375 3.40821094,1.8181875 5.81817187,1.8181875 C6.82654687,1.8181875 7.75490625,2.16039844 8.49379687,2.73478125 L7.45303125,3.77554687 C6.98709375,3.45834375 6.42433594,3.27274219 5.81814844,3.27274219 C4.21148437,3.27274219 2.9090625,4.5751875 2.9090625,6.18182812 C2.9090625,7.78846875 4.21150781,9.09091406 5.81814844,9.09091406 C7.42478906,9.09091406 8.72723437,7.78846875 8.72723437,6.18182812 C8.72723437,5.57564062 8.54163281,5.01288281 8.22442969,4.54694531 L9.26519531,3.50617969 C9.83960156,4.24509375 10.1817656,5.17345312 10.1817656,6.18180469 C10.1818125,8.59178906 8.22810937,10.5454453 5.81817187,10.5454453 Z M5.57175,6.42822656 C5.78472656,6.64125 6.130125,6.64125 6.34317187,6.42822656 L7.15760156,5.61379688 C7.23166406,5.78833594 7.27272656,5.9803125 7.27272656,6.18182813 C7.27272656,6.98517188 6.62149219,7.63638281 5.81817187,7.63638281 C5.01485156,7.63638281 4.36361719,6.98517188 4.36361719,6.18182813 C4.36361719,5.37848438 5.01485156,4.72727344 5.81817187,4.72727344 C6.01971094,4.72727344 6.21166406,4.76828906 6.38617969,4.84239844 L5.57175,5.65682813 C5.35877344,5.86982813 5.35877344,6.21520313 5.57175,6.42822656 Z",
    id: "path-goal"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5393FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004AC9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "High-Fi-Dashboard-T2P",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picking---T2P",
    transform: "translate(-666.000000, -301.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wrapper"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picking-[Div]",
    transform: "translate(0.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Meta-Agencia-[Col-4]",
    transform: "translate(596.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "goal",
    transform: "translate(14.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-goal",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-goal"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8Color",
    mask: "url(#mask-goal)",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Gradient",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.5e7bf448e680273664e43769227d1ca0.svg";
export { ForwardRef as ReactComponent };